import * as React from 'react'
import { styles } from './styles.css'
import instagram from './instagram.svg'

export const FooterSection: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <ul className={styles.links}>
        <li>
          <a className={styles.link} href="https://flowr.is/">FLOWER公式サイト</a>
        </li>
        <li>
          <a className={styles.link} href="https://flowr.jp/">運営会社</a>
        </li>
        <li>
          <a className={styles.link} href="https://flowr.is/policy">プライバシーポリシー</a>
        </li>
        <li>
          <a className={styles.link} href="https://flowr.is/terms">利用規約</a>
        </li>
        <li>
          <a className={styles.link} href="https://flowr.is/commercial">特定商取引法に基づく表示</a>
        </li>
      </ul>
      <a href="https://www.instagram.com/flowr_is/" target="_blank" className={styles.instagram}>
        <img src={instagram} alt="FLOWER公式Instagram" />
      </a>
    </footer>
  )
}
